import http from '../http-common';

class CatalogoService {
    userInfo() {
        return http.get('/profile/userinfo');
    }

    listadoEstados() {
        return http.get('/estados');
    }

    listadoComprobantes() {
        return http.get('/tipo-comprobantes');
    }

    listadoTipoPresentaciones() {
        return http.get('/tipo-presentaciones');
    }

    listadoTipoPrestaciones() {
        return http.get('/tipo-prestaciones');
    }

    listadoTipoPrestacionesByTipoPresentacion(idPresentacion) {
        return http.get('/tipo-presentacion/' + idPresentacion + '/tipo-prestaciones')
    }

    listadoTipoComprobantesByTipoPresentacion(idPresentacion) {
        return http.get('/tipo-presentacion/' + idPresentacion + '/tipo-comprobantes')
    }
}

export default new CatalogoService();
